import { render, staticRenderFns } from "./ImportBatch.vue?vue&type=template&id=4074af2e&scoped=true&"
import script from "./ImportBatch.vue?vue&type=script&lang=js&"
export * from "./ImportBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4074af2e",
  null
  
)

export default component.exports